import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { login_success, logout } from "../../actions/user";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { Link } from "react-router-dom";
// import "./style.scss";
import methodModel from "../../methods/methods";
import { ToastContainer, toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import environment from "../../environment";
import DOMPurify from "dompurify";
import { getBokunKey } from "../../utils/bokun-utils";

const Login = () => {
  const history = useNavigate();
  const newUser =
    methodModel.getPrams("newuser") || methodModel.getPrams("newUser");
  const WebDetails = useSelector((state) => state.logo);
  const user = useSelector((state) => state.user);
  const [ip, setIp] = useState("");
  const [resp, setRes] = useState();
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [remember, setRemember] = useState(false);
  const [LoginError, setLoginError] = useState(null);
  const [password, setPassword] = useState("");
  const [otp, setOTP] = useState("");
  const [step, setStep] = useState(1);
  const [eyes, setEyes] = useState({
    password: false,
    confirmPassword: false,
    currentPassword: false,
  });
  const setLogin = async (userData2, type = "") => {
    const userdata = {
      ...userData2,
      id: userData2?._id || userData2?.id,
      _id: userData2?._id || userData2?.id,
    };
    loader(true);
    storeAuthData(userdata);
    methodModel.CookieUtil.setCookieDay(
      "loggedInUser",
      JSON.stringify({
        companyName: userdata?.companyName,
        id: userdata?.id,
        logo: userdata?.logo,
      }),
      7,
    );
    handleExistingUserLogin(userdata);
  };

  // Helper to store authentication data
  const storeAuthData = (data) => {
    localStorage.setItem("token", data?.access_token);
    localStorage.setItem("_id", data?._id);
  };

  // Helper to handle existing user login
  const handleExistingUserLogin = (data) => {
    dispatch(
      login_success({
        ...data,
        supplier_id: {
          ...data?.supplier_id,
          _id: data?.supplier_id?.id || data?.supplier_id?._id,
        },
      }),
    );
    loader(false);
    history("/dashboard");
  };

  const hendleSubmit = (e) => {
    e.preventDefault();
    setLoginError(null);
    let data = {
      email: username,
      password,
    };
    localStorage.setItem("SignUpEmail", data?.email);
    localStorage.setItem("user_id", resp?._id);
    loader(true);

    let url = "user/admin/sign-in";
    if (step == 2) {
      url = "user/verifyOtp";
      data = {
        email: username,
        otp: otp,
      };
    }

    ApiClient.post(url, data, "", true, setLoginError)
      .then((res) => {
        loader(false);
        if (res.success) {
          if (remember) {
            localStorage.setItem("remember", JSON.stringify(data));
          } else {
            localStorage.removeItem("remember");
          }

          if (res.data.two_factor_email_sent || step == 2) {
            localStorage.setItem("user_id", res.data?._id);
            if (step == 2) {
              setLogin(resp);
            }
            setStep(2);
            setRes(res.data);
          } else {
            setLogin(res.data);
          }
        }
      })
      .catch((err) => {});
  };

  const router = () => {
    history("/otppage");
  };

  const [OTPSENT, setOTPSENT] = useState(false);
  const HandleOTPResender = (e) => {
    if (OTPSENT) {
      return;
    }
    e.preventDefault();
    ApiClient.post(`user/resend/otp`, { email: username }).then((res) => {
      if (res.success) {
        setOTPSENT(true);
        setTimeout(() => {
          setOTPSENT(false);
        }, 3000);
      }
    });
  };

  return (
    <>
      <div
        onClick={(e) => router()}
        className="hidden"
        id="routerDivlogin"
      ></div>
      <div className="">
        <div
          className="h-screen overflow-auto flex items-start p-5"
          style={{ backgroundImage: "url('/assets/img/auth-bg.webp')" }}
        >
          <div className="max-w-[550px] w-full h-fit bg-white rounded-[40px] sm:p-[4rem] p-[1.5rem] m-auto">
            <div className="w-full bg-white">
              <img
                src="/assets/img/logo.png"
                className="w-[110px] object-contain mx-auto mb-4"
                alt="logo"
              />
              <div className="">
                <form onSubmit={hendleSubmit}>
                  <div className="mb-5">
                    <h2 className="text-[28px] font-[500] text-[#115B9D] text-center">
                      Welcome Back
                    </h2>
                    <h3 class="text-[22px] font-[600] text-center leding-[28px]">
                      Login
                    </h3>
                  </div>

                  {step == 1 ? (
                    <>
                      <div className="space-y-4">
                        <div className="">
                          <p class="text-sm pb-1 font-[400] text-[#737373]">
                            Email
                          </p>
                          <input
                            type="email"
                            autoComplete="off"
                            className="border !outline-none h-11 rounded-[12px] w-full text-sm pl-3 pr-9"
                            placeholder="Email address"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                          />
                        </div>
                        <div className="">
                          <p class="text-sm pb-1 font-[400] text-[#737373]">
                            Password
                          </p>
                          <div className="relative">
                            <input
                              type={eyes.password ? "text" : "password"}
                              className="border !outline-none h-11 rounded-[12px] w-full text-sm pl-3 pr-9"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder="Password"
                              autoComplete="off"
                              required
                            />
                            {eyes.password ? (
                              <FaEye
                                className="top-[15px] right-3 absolute text-gray-600 hover:opacity-80 cursor-pointer"
                                onClick={() =>
                                  setEyes({ ...eyes, password: !eyes.password })
                                }
                              />
                            ) : (
                              <FaEyeSlash
                                className="top-[15px] right-3 absolute text-gray-600 hover:opacity-80 cursor-pointer"
                                onClick={() =>
                                  setEyes({ ...eyes, password: !eyes.password })
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <p className="mb-2">OTP sent on email</p>
                      <input
                        type="text"
                        maxLength={6}
                        minLength={6}
                        className="border !outline-none h-11 rounded-[12px] w-full text-sm pl-3 pr-9"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOTP(e.target.value.trim())}
                        required
                      />
                    </>
                  )}

                  <div className="flex justify-end mt-3">
                    {step == 1 ? (
                      <Link
                        to="/forgotpassword"
                        className="text-[14px] text-gray-500 cursor-pointer hover:underline"
                      >
                        Forgot Password?
                      </Link>
                    ) : (
                      <p
                        className="text-[#115B9D]  "
                        onClick={(e) => HandleOTPResender(e)}
                      >
                        {OTPSENT ? (
                          "Sent Successfully"
                        ) : (
                          <span className="cursor-pointer">Resend OTP</span>
                        )}
                      </p>
                    )}
                  </div>

                  <div className="mt-7">
                    {LoginError ? (
                      <div
                        className={`px-4 py-2 mb-4 bg-red-400 text-center rounded-large flex items-center justify-between transition-transform duration-500 ${LoginError ? "transform translate-y-0" : "transform -translate-y-full"}`}
                      >
                        <span className="text-white text-sm text-center">
                          {LoginError}
                        </span>
                      </div>
                    ) : null}
                    <button
                      type="submit"
                      className="!px-4 w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 !bg-[#115B9D] rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                    >
                      Login
                    </button>
                  </div>
                  {/* <div className="flex items-center gap-3 mt-5">
                    <div className="w-full h-[1px] bg-[#E8E8E8]" />
                    <span className="text-sm text-[#484848]">or</span>
                    <div className="w-full h-[1px] bg-[#E8E8E8]" />
                  </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
};

export default Login;
